import React from "react";

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import axios from 'axios';
import { convertAmount } from './utils'
import {conversionOptions} from './options';

/*
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
*/
const yesterday = dayjs().add(-1, 'day');

export default function CurrencyConverter({ currOptions, defaultValue }) {
    //console.log("CurrencyConverter");
    //console.log(currOptions, convOptions)
    //var currencyData = [];
    //var obj = {};

    function validate(fcurrency, framount, conversion, startDate, endDate, tcurrency) {
        if (framount.length === 0) {
            return false;
        }
        return true
    }

    function getParams(fcurrency, framount, conversion, startDate, endDate, tcurrency) {
        // TODO: This needs to get the date elements and be contructed by hand
        // - can't directly use ISOString because of the timezone issues
        //const currentIsoDateString = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString()
        let tdate;
        if (conversion === 'Average') {
            const sdate = new Date(startDate.$d - startDate.$d.getTimezoneOffset() * 60000).toISOString().substring(0,10)
            const edate = new Date(endDate.$d - endDate.$d.getTimezoneOffset() * 60000).toISOString().substring(0,10)
            //console.log(sdate, edate);
            if (new Date(sdate) > new Date(edate)) {
                alert('The from date must be earlier than the to date.');
                return false;
            }
            tdate = sdate + ':' + edate;
        } else {
            tdate = new Date(startDate.$d - startDate.$d.getTimezoneOffset() * 60000).toISOString().substring(0,10)
            tdate = tdate + ':' + tdate;
        }
        let data = {
            'direction': 'from',
            'from_currency': fcurrency,
            'from_amount': framount,
            'to_currency': tcurrency,
            'to_amount': 0,
            'tdate': tdate
        }
        //console.log(data);
        return data
    }
    const [toamount, setToAmount] = React.useState('')
    const [rate, setRate] = React.useState('')

    const [fcurrency, setFrCurrency] = React.useState(currOptions[defaultValue].value);
    const handleFrCurrency = (event) => {
        setFrCurrency(event.target.value);
    };
    const [conversion, setConversion] = React.useState(conversionOptions[0].label);
    const handleConversion = (event) => {
        setConversion(event.target.value);
        if (event.target.value === 'Average') {
            //console.log("Show end date")
            document.getElementById("end-date").style.visibility = "visible";
        } else {
            document.getElementById("end-date").style.visibility = "hidden";
        }
    };

    const [startDate, setStartDate] = React.useState(yesterday);
    //const handleStartDate = (event) => {
    //    setStartDate(event.target.value);
    //}

    const [endDate, setEndDate] = React.useState(yesterday);
    //const handleEndDate = (event) => {
    //    setEndDate(event.target.value)
    //}

    const [framount, setFrAmount] = React.useState('');
    const [frxamount, setFrxAmount] = React.useState(framount);
    const handleFrAmount = (event) => {
        if (event._reactName === "onChange") {
            setFrAmount(event.target.value);
        } else { // onBlur
            //console.log(event.target.value);
            setFrxAmount(event.target.value);
        }
    }

    const [tcurrency, setToCurrency] = React.useState(currOptions[defaultValue].value);
    const handleToCurrency = (event) => {
        setToCurrency(event.target.value);
    };

    const handleButtonClick = () => {
        let URL= 'api/exchange_rate';
        if (process.env.NODE_ENV === 'development') {
            URL= 'http://localhost:8081/api/exchange_rate';
        }
        axios.get(URL,
                {
                params: getParams(fcurrency, framount, conversion, startDate, endDate, tcurrency)
            }
        )
            .then(response => {
                //console.log(response.data);
                // Check if there is an error message
                if ( 'msg' in response.data) {
                    alert(response.data.msg);
                    // clear the toamount and the rate if there is an error
                    return false;
                }
                // now set the to_amount and the rate

                setToAmount(convertAmount(response.data.to_amount, 6));
                setRate(convertAmount(response.data.exrate,6));

            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

    React.useEffect(() => {
        if (validate(fcurrency, frxamount, conversion, startDate, endDate)) {
            handleButtonClick();
        }
    }, [fcurrency, tcurrency, frxamount, startDate, endDate]);

    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 2 }}>
                <InputLabel sx={{ fontSize: 18, fontWeight: 'bold' }}>Currency Conversion</InputLabel>
            </Grid>
            <Grid item xs={2}>
                <FormControl fullWidth >
                    <InputLabel sx={{ pt: 0.1, pb: 0.1 }} id="frcurrency-label">From Currency</InputLabel>
                    <Select
                        labelId="frcurrency-label"
                        label="From Currency"
                        name="From Currency"
                        id="frcurrency"
                        size="small"
                        value={fcurrency}
                        onChange={handleFrCurrency}
                    >
                        {currOptions.map((fcurrency) => (
                            <MenuItem key={fcurrency.value} value={fcurrency.value}>
                                {fcurrency.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={3}>
                <TextField
                    id="framount"
                    label="Amount"
                    name="framount"
                    size="small"
                    value={framount}
                    onBlur={handleFrAmount}
                    onChange={handleFrAmount}
                    inputProps={{ style: { textAlign: 'right' } }} // the change is here
                />
            </Grid>
            <Grid item xs={2}>
                <FormControl fullWidth >
                    <InputLabel id="conversion-type-label">Conversion Type</InputLabel>
                    <Select
                        labelId="conversion-type-label"
                        id="conversion-type"
                        value={conversion}
                        label="Conversion Type"
                        onChange={handleConversion}
                        size="small"
                    >
                        {conversionOptions.map((conversion) => (
                            <MenuItem key={conversion.value} value={conversion.value}>
                                {conversion.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={2} id="start-date">
                <FormControl fullWidth >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Start Date"
                            id="start-date"
                            format="DD/MM/YY"
                            //selected={startDate}
                            value={startDate}
                            slotProps={{ textField: { size: 'small' } }}
                            onChange={(newValue) => setStartDate(newValue)}
                            defaultValue={yesterday}
                            maxDate={yesterday}
                        />
                    </LocalizationProvider>
                </FormControl>
            </Grid>
            <Grid item xs={2} id="end-date" sx={{ visibility: 'hidden' }}>
                <FormControl fullWidth >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="End Date"
                            id="end-date"
                            format="DD/MM/YY"
                            //selected={endDate}
                            value={endDate}
                            slotProps={{ textField: { size: 'small' } }}
                            defaultValue={yesterday}
                            maxDate={yesterday}
                            onChange={(newValue) => setEndDate(newValue)}
                            //onChange={handleEndDate}
                        />
                    </LocalizationProvider>
                </FormControl>
            </Grid>
            <Grid item xs={2}>
                <FormControl fullWidth >
                    <InputLabel sx={{ pt: 0.1, pb: 0.1 }} id="tocurrency-label">To Currency</InputLabel>
                    <Select
                        size="small"
                        labelId="tocurrency-label"
                        label="To Currency"
                        id="tocurrency"
                        value={tcurrency}
                        onChange={handleToCurrency}
                    >
                        {currOptions.map((tocurrency) => (
                            <MenuItem key={tocurrency.value} value={tocurrency.value}>
                                {tocurrency.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={3}>
                <TextField
                    readOnly
                    id="toamount"
                    label="Amount"
                    name="toamount"
                    disabled
                    value={toamount}
                    size="small"
                    inputProps={{ style: { textAlign: 'right' } }} // the change is here
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    disabled
                    id="rate"
                    label="Rate"
                    name="rate"
                    value={rate}
                    size="small"
                    inputProps={{ style: { textAlign: 'right' } }} // the change is here
                />
            </Grid>
        </React.Fragment>
    );
}
